import React from 'react'
import FormErrorMessage from 'components/form-components/Contact/FormErrorMessage'
import PropTypes from 'prop-types'
import { ErrorMessage } from 'formik'
import {
  InputBlock,
  InputWrap,
  DropArea,
  DropAreaText,
  DropAreaSubtitle,
} from 'styles/drop-area'
import styled from 'styled-components'
import AddIcon from 'images/plus.svg'
import RemoveIcon from 'images/close.svg'

const Container = styled.section`
  ${({ hasSelctedImages }) =>
    hasSelctedImages &&
    `
    display: flex;
  `}
`

const InputBlockStyle = styled(InputBlock)`
  && {
    background-color: rgba(255, 255, 255, 1);
    margin-top: ${noMargin => (noMargin ? '0' : '10px')};
    ${noMargin => noMargin && 'margin-bottom: 0;'};
    ${({ hasSelctedImages }) =>
      hasSelctedImages &&
      `
      width: 88px;
      height: 88px;
      margin-top: 0;
      margin-left: 8px;
    `}
  }
`

const DropAreaStyle = styled(DropArea)`
  && {
    border: 1px solid rgba(232, 236, 243, 1);
    padding: 64px 16px;
    ${({ hasSelctedImages }) =>
      hasSelctedImages &&
      `
      padding: 0;
      border: 0;
    `}
    ${({ isDragActive }) =>
      isDragActive &&
      `
      background-color: rgba(232, 236, 243, 1);
      border: 1px dashed rgba(67, 70, 77, 1);
    `}
  }
`

const DropAreaWrapperImages = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`

const ImageWrapper = styled.div`
  position: relative;
  width: 88px;
  height: 88px;
  overflow: hidden;
  & > img {
    width: 100%;
    height: 100%;
    /* max-width: 88px; */
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
  }
`

const RemoveButtonWrapper = styled.span`
  position: absolute;
  top: 4px;
  right: 4px;
  z-index: 1;
  border: 1px solid rgba(232, 236, 243, 1);
  background-color: rgba(255, 255, 255, 1);
  border-radius: 50%;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`

const RowBlockStyle = styled.div`
  margin-top: 12px;
`

const RemoveAllButton = styled.span`
  color: rgba(0, 0, 0, 1);
  font-size: 14px;
  font-family: Montserrat;
  font-weight: 500;
  line-height: 20px;
  text-decoration-line: underline;
  cursor: pointer;
`

const FormImage = ({
  field,
  error,
  isSelectedImagesActive,
  selectedImages,
  translataions,
  isDragActive,
  isRemoveAllActive,
  onRemoveImage,
  onRemoveAll,
  getRootProps,
  getInputProps,
  isMultiple,
}) => (
  <>
    <Container hasSelctedImages={isSelectedImagesActive}>
      {isSelectedImagesActive && (
        <DropAreaWrapperImages>
          {selectedImages.map(image => (
            <ImageWrapper key={image.name}>
              <RemoveButtonWrapper onClick={() => onRemoveImage(image)}>
                <RemoveIcon />
              </RemoveButtonWrapper>
              <img src={URL.createObjectURL(image)} alt={image.name} />
            </ImageWrapper>
          ))}
        </DropAreaWrapperImages>
      )}

      {(isMultiple || !isSelectedImagesActive) && (
        <InputBlockStyle hasSelctedImages={isSelectedImagesActive}>
          <InputWrap>
            <div {...getRootProps()}>
              <input {...getInputProps()} />
              {isDragActive ? (
                <DropAreaStyle
                  hasSelctedImages={isSelectedImagesActive}
                  isDragActive={isDragActive}
                >
                  <DropAreaText>Drop the files here ...</DropAreaText>
                </DropAreaStyle>
              ) : (
                <DropAreaStyle
                  hasSelctedImages={isSelectedImagesActive}
                  isDragActive={isDragActive}
                >
                  {isSelectedImagesActive && field.value !== '' ? (
                    <AddIcon />
                  ) : (
                    <>
                      <DropAreaSubtitle>
                        {translataions.description}
                      </DropAreaSubtitle>
                      <DropAreaSubtitle>
                        {translataions.description2}
                      </DropAreaSubtitle>
                    </>
                  )}
                </DropAreaStyle>
              )}
            </div>
          </InputWrap>
          <ErrorMessage component={FormErrorMessage} name={field.name} />
          {error && <FormErrorMessage>{error}</FormErrorMessage>}
        </InputBlockStyle>
      )}
    </Container>
    {isRemoveAllActive && (
      <RowBlockStyle>
        <RemoveAllButton onClick={onRemoveAll}>
          {translataions.removeAll}
        </RemoveAllButton>
      </RowBlockStyle>
    )}
  </>
)

FormImage.propTypes = {
  field: PropTypes.any,
  onChange: PropTypes.any,
  isMultiple: PropTypes.bool,
}

FormImage.defaultProps = {
  isMultiple: false,
}

export default FormImage
